import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadBtKreisListStatus: 'idle',
    loadBtKreisListError: undefined as any,
    loadBtKreisListLastArgs: undefined as any,
    loadBtKreisStatus: 'idle',
    loadBtKreisError: undefined as any,
    saveBtKreisStatus: 'idle',
    saveBtKreisError: undefined as any,
    deleteBtKreisStatus: 'idle',
    deleteBtKreisError: undefined as any,

    btKreisList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadBtKreisList = createAsyncThunk('btKreisSlice/loadBtKreisList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().btKreisSlice.loadBtKreisListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreis/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisListStatus } = getState().btKreisSlice
        return loadBtKreisListStatus !== 'pending'
    }
})

export const loadBtKreis = createAsyncThunk('btKreisSlice/loadBtKreis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreis/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisStatus } = getState().btKreisSlice
        return loadBtKreisStatus !== 'pending'
    }
})

export const saveBtKreis = createAsyncThunk('btKreisSlice/saveBtKreis', async ({ btKreis }: any, { rejectWithValue }: any) => {
    let promises = []
    if (btKreis?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/btkreis/${ btKreis?.HDR_ID }/`,
            prepareData(btKreis),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/btkreis/`,
            prepareData(btKreis),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveBtKreisStatus } = getState().btKreisSlice
        return saveBtKreisStatus !== 'pending'
    }
})

export const deleteBtKreis = createAsyncThunk('btKreisSlice/deleteBtKreis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/btkreis/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteBtKreisStatus } = getState().btKreisSlice
        return deleteBtKreisStatus !== 'pending'
    }
})

const BtKreisSlice = createSlice({
    name: 'btKreisSlice',
    initialState,
    reducers: {
        resetloadBtKreisListError: (state) => {
            state.loadBtKreisListError = undefined
        },
        resetloadBtKreis: (state) => {
            state.formItem = undefined
            state.loadBtKreisError = undefined
        },
        resetloadBtKreisError: (state) => {
            state.loadBtKreisError = undefined
        },
        resetsaveBtKreis: (state) => {
            state.formItem = undefined
            state.saveBtKreisError = undefined
        },
        resetsaveBtKreisError: (state) => {
            state.saveBtKreisError = undefined
        },
        resetdeleteBtKreisError: (state) => {
            state.deleteBtKreisError = undefined
        },
        removeFromBtKreisListById: (state, action) => {
            state.btKreisList = state.btKreisList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromBtKreisListByIds: (state, action) => {
            state.btKreisList = state.btKreisList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.btKreisList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadBtKreisListStatus = 'preloaded'
            state.loadBtKreisListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.btKreisList = []
            state.loadBtKreisListStatus = 'idle'
            state.loadBtKreisListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadBtKreisList.pending, (state) => {
            state.loadBtKreisListStatus = 'pending'
            state.loadBtKreisListError = undefined
        })
        builder.addCase(loadBtKreisList.fulfilled, (state, action) => {
            state.loadBtKreisListStatus = 'idle'

            if (!action.payload) { return }

            state.loadBtKreisListLastArgs = action.payload.args

            {
                state.btKreisList = action.payload.data

            }
        })
        builder.addCase(loadBtKreisList.rejected, (state, action) => {
            state.loadBtKreisListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisListError = action.error.message
            } else {
                state.loadBtKreisListError = action.payload
            }
        })

        builder.addCase(loadBtKreis.pending, (state) => {
            state.loadBtKreisStatus = 'pending'
            state.loadBtKreisError = undefined
        })
        builder.addCase(loadBtKreis.fulfilled, (state, action) => {
            state.loadBtKreisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.btKreisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.btKreisList.push(newItem) }
                else { state.btKreisList[i] = { ...state.btKreisList[i], ...newItem } }
            }
        })
        builder.addCase(loadBtKreis.rejected, (state, action) => {
            state.loadBtKreisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisError = action.error.message
            } else {
                state.loadBtKreisError = action.payload
            }
        })

        builder.addCase(saveBtKreis.pending, (state) => {
            state.saveBtKreisStatus = 'pending'
            state.saveBtKreisError = undefined
        })
        builder.addCase(saveBtKreis.fulfilled, (state, action) => {
            state.saveBtKreisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.btKreisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.btKreisList.push(newItem) }
                else { state.btKreisList[i] = { ...state.btKreisList[i], ...newItem } }
            }
        })
        builder.addCase(saveBtKreis.rejected, (state, action) => {
            state.saveBtKreisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveBtKreisError = action.error.message
            } else {
                state.saveBtKreisError = action.payload
            }
        })

        builder.addCase(deleteBtKreis.pending, (state) => {
            state.deleteBtKreisStatus = 'pending'
            state.deleteBtKreisError = undefined
        })
        builder.addCase(deleteBtKreis.fulfilled, (state, action) => {
            state.deleteBtKreisStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.btKreisList = state.btKreisList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.btKreisList = state.btKreisList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteBtKreis.rejected, (state, action) => {
            state.deleteBtKreisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteBtKreisError = action.error.message
            } else {
                state.deleteBtKreisError = action.payload
            }
        })

    }
})

export const {
    resetloadBtKreisListError,
    resetloadBtKreis,
    resetloadBtKreisError,
    resetsaveBtKreis,
    resetsaveBtKreisError,
    resetdeleteBtKreisError,
    removeFromBtKreisListById,
    removeFromBtKreisListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = BtKreisSlice.actions
export default BtKreisSlice.reducer
